import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import { Fragment } from "react";
import TooltipContainer from "./TooltipContainer";

const ConfirmationModal =({children, data, buttonContent, color, content, handle})=> {

  const {isOpen, onOpen, onClose, onOpenChange} = useDisclosure();

  const handleClick = () => {
    handle(data);
    onClose();
  }

  return (
    <Fragment>
      <TooltipContainer color={color || "primary"} content={buttonContent}>
        <Button color={color || "primary"} onPress={onOpen} isIconOnly size='sm'>
          {children}
        </Button>
      </TooltipContainer>
      <Modal 
      backdrop="opaque" 
      isOpen={isOpen} 
      onOpenChange={onOpenChange}
      classNames={{
        backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20"
      }}
      >
        <ModalContent>
          {(onClose) => (
            <Fragment>
              <ModalHeader className="flex flex-col gap-1">{buttonContent}</ModalHeader>
              <ModalBody>
                <p>{content}</p>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                <Button color="primary" onPress={handleClick}>
                  Confirm
                </Button>
              </ModalFooter>
            </Fragment>
          )}
        </ModalContent>
      </Modal>
    </Fragment>
  );
}

export default ConfirmationModal